/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = () => {
  return {
  };
};

export default getStyles;
